"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Object = _interopRequireDefault(require("../Object.js"));

var _Units = _interopRequireDefault(require("../proj/Units.js"));

var _util = require("../util.js");

var _transform = require("../transform.js");

var _extent = require("../extent.js");

var _proj = require("../proj.js");

var _functions = require("../functions.js");

var _transform2 = require("./flat/transform.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/geom/Geometry
 */


/**
 * @type {import("../transform.js").Transform}
 */
var tmpTransform = (0, _transform.create)();
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for vector geometries.
 *
 * To get notified of changes to the geometry, register a listener for the
 * generic `change` event on your geometry instance.
 *
 * @abstract
 * @api
 */

var Geometry =
/** @class */
function (_super) {
  __extends(Geometry, _super);

  function Geometry() {
    var _this = _super.call(this) || this;
    /**
     * @private
     * @type {import("../extent.js").Extent}
     */


    _this.extent_ = (0, _extent.createEmpty)();
    /**
     * @private
     * @type {number}
     */

    _this.extentRevision_ = -1;
    /**
     * @protected
     * @type {number}
     */

    _this.simplifiedGeometryMaxMinSquaredTolerance = 0;
    /**
     * @protected
     * @type {number}
     */

    _this.simplifiedGeometryRevision = 0;
    /**
     * Get a transformed and simplified version of the geometry.
     * @abstract
     * @param {number} revision The geometry revision.
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../proj.js").TransformFunction} [opt_transform] Optional transform function.
     * @return {Geometry} Simplified geometry.
     */

    _this.simplifyTransformedInternal = (0, _functions.memoizeOne)(function (revision, squaredTolerance, opt_transform) {
      if (!opt_transform) {
        return this.getSimplifiedGeometry(squaredTolerance);
      }

      var clone = this.clone();
      clone.applyTransform(opt_transform);
      return clone.getSimplifiedGeometry(squaredTolerance);
    });
    return _this;
  }
  /**
   * Get a transformed and simplified version of the geometry.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [opt_transform] Optional transform function.
   * @return {Geometry} Simplified geometry.
   */


  Geometry.prototype.simplifyTransformed = function (squaredTolerance, opt_transform) {
    return this.simplifyTransformedInternal(this.getRevision(), squaredTolerance, opt_transform);
  };
  /**
   * Make a complete copy of the geometry.
   * @abstract
   * @return {!Geometry} Clone.
   */


  Geometry.prototype.clone = function () {
    return (0, _util["abstract"])();
  };
  /**
   * @abstract
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */


  Geometry.prototype.closestPointXY = function (x, y, closestPoint, minSquaredDistance) {
    return (0, _util["abstract"])();
  };
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */


  Geometry.prototype.containsXY = function (x, y) {
    var coord = this.getClosestPoint([x, y]);
    return coord[0] === x && coord[1] === y;
  };
  /**
   * Return the closest point of the geometry to the passed point as
   * {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} point Point.
   * @param {import("../coordinate.js").Coordinate} [opt_closestPoint] Closest point.
   * @return {import("../coordinate.js").Coordinate} Closest point.
   * @api
   */


  Geometry.prototype.getClosestPoint = function (point, opt_closestPoint) {
    var closestPoint = opt_closestPoint ? opt_closestPoint : [NaN, NaN];
    this.closestPointXY(point[0], point[1], closestPoint, Infinity);
    return closestPoint;
  };
  /**
   * Returns true if this geometry includes the specified coordinate. If the
   * coordinate is on the boundary of the geometry, returns false.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {boolean} Contains coordinate.
   * @api
   */


  Geometry.prototype.intersectsCoordinate = function (coordinate) {
    return this.containsXY(coordinate[0], coordinate[1]);
  };
  /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */


  Geometry.prototype.computeExtent = function (extent) {
    return (0, _util["abstract"])();
  };
  /**
   * Get the extent of the geometry.
   * @param {import("../extent.js").Extent} [opt_extent] Extent.
   * @return {import("../extent.js").Extent} extent Extent.
   * @api
   */


  Geometry.prototype.getExtent = function (opt_extent) {
    if (this.extentRevision_ != this.getRevision()) {
      var extent = this.computeExtent(this.extent_);

      if (isNaN(extent[0]) || isNaN(extent[1])) {
        (0, _extent.createOrUpdateEmpty)(extent);
      }

      this.extentRevision_ = this.getRevision();
    }

    return (0, _extent.returnOrUpdate)(this.extent_, opt_extent);
  };
  /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */


  Geometry.prototype.rotate = function (angle, anchor) {
    (0, _util["abstract"])();
  };
  /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [opt_sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [opt_anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */


  Geometry.prototype.scale = function (sx, opt_sy, opt_anchor) {
    (0, _util["abstract"])();
  };
  /**
   * Create a simplified version of this geometry.  For linestrings, this uses
   * the [Douglas Peucker](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm)
   * algorithm.  For polygons, a quantization-based
   * simplification is used to preserve topology.
   * @param {number} tolerance The tolerance distance for simplification.
   * @return {Geometry} A new, simplified version of the original geometry.
   * @api
   */


  Geometry.prototype.simplify = function (tolerance) {
    return this.getSimplifiedGeometry(tolerance * tolerance);
  };
  /**
   * Create a simplified version of this geometry using the Douglas Peucker
   * algorithm.
   * See https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Geometry} Simplified geometry.
   */


  Geometry.prototype.getSimplifiedGeometry = function (squaredTolerance) {
    return (0, _util["abstract"])();
  };
  /**
   * Get the type of this geometry.
   * @abstract
   * @return {import("./GeometryType.js").default} Geometry type.
   */


  Geometry.prototype.getType = function () {
    return (0, _util["abstract"])();
  };
  /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @abstract
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   */


  Geometry.prototype.applyTransform = function (transformFn) {
    (0, _util["abstract"])();
  };
  /**
   * Test if the geometry and the passed extent intersect.
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   */


  Geometry.prototype.intersectsExtent = function (extent) {
    return (0, _util["abstract"])();
  };
  /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @abstract
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */


  Geometry.prototype.translate = function (deltaX, deltaY) {
    (0, _util["abstract"])();
  };
  /**
   * Transform each coordinate of the geometry from one coordinate reference
   * system to another. The geometry is modified in place.
   * For example, a line will be transformed to a line and a circle to a circle.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   *
   * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @return {Geometry} This geometry.  Note that original geometry is
   *     modified in place.
   * @api
   */


  Geometry.prototype.transform = function (source, destination) {
    /** @type {import("../proj/Projection.js").default} */
    var sourceProj = (0, _proj.get)(source);
    var transformFn = sourceProj.getUnits() == _Units["default"].TILE_PIXELS ? function (inCoordinates, outCoordinates, stride) {
      var pixelExtent = sourceProj.getExtent();
      var projectedExtent = sourceProj.getWorldExtent();
      var scale = (0, _extent.getHeight)(projectedExtent) / (0, _extent.getHeight)(pixelExtent);
      (0, _transform.compose)(tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
      (0, _transform2.transform2D)(inCoordinates, 0, inCoordinates.length, stride, tmpTransform, outCoordinates);
      return (0, _proj.getTransform)(sourceProj, destination)(inCoordinates, outCoordinates, stride);
    } : (0, _proj.getTransform)(sourceProj, destination);
    this.applyTransform(transformFn);
    return this;
  };

  return Geometry;
}(_Object["default"]);

var _default = Geometry;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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